var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h2", { staticClass: "mb-10" }, [_vm._v("Acuerdo CORE")]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Descripción acuerdo *" } },
                  [
                    _c("editor-text", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      ref: "description",
                      attrs: {
                        danger: _vm.errors.has("custom-document.description"),
                        "danger-text": _vm.errors.first(
                          "custom-document.description"
                        ),
                        "data-cy": "description",
                        "data-vv-as": "descripción",
                        "max-length": _vm.maxLengthDescription,
                        name: "description",
                        "with-counter": ""
                      },
                      model: {
                        value: _vm.formData.description,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "description", $$v)
                        },
                        expression: "formData.description"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-3 mt-2" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Fecha de documento *" } },
                  [
                    _c("date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        "data-cy": "document-date",
                        name: "documentDate",
                        format: "DD-MM-YYYY",
                        "value-type": "YYYY-MM-DD",
                        "data-vv-as": "fecha de documento",
                        danger: _vm.errors.has("custom-document.documentDate"),
                        "danger-text": _vm.errors.first(
                          "custom-document.documentDate"
                        )
                      },
                      model: {
                        value: _vm.formData.documentDate,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "documentDate", $$v)
                        },
                        expression: "formData.documentDate"
                      }
                    }),
                    _vm.errors.has("custom-document.documentDate")
                      ? _c("div", [
                          _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "custom-document.documentDate"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "col-md-6 mt-2" }, [
              _vm._v(" Orientación de documento "),
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: {
                          "vs-name": "portrait",
                          "vs-value": "Portrait",
                          "data-cy": "portrait"
                        },
                        model: {
                          value: _vm.formData.orientation,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "orientation", $$v)
                          },
                          expression: "formData.orientation"
                        }
                      },
                      [_vm._v(" Vertical ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: {
                          "vs-name": "landscape",
                          "vs-value": "Landscape",
                          "data-cy": "landscape"
                        },
                        model: {
                          value: _vm.formData.orientation,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "orientation", $$v)
                          },
                          expression: "formData.orientation"
                        }
                      },
                      [_vm._v(" Horizontal ")]
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "row align-items-center mt-5" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "col-md-3 align-items-end" },
              [
                _c("upload-file", {
                  attrs: {
                    permission: "*",
                    accept: "application/pdf, .doc, .docx, .xlsv, .ppt",
                    text: "Seleccionar documentos",
                    "upload-to": "ed",
                    "button-class": {
                      "btn-block": true,
                      "mb-5": _vm.errors.has("custom-document.fileName")
                    },
                    "container-class": "w-100"
                  },
                  on: {
                    input: function($event) {
                      return _vm.addFile()
                    }
                  },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "row align-items-center mt-1" },
            [
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED060",
                          expression: "'ED060'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "add-file-repository",
                          expression: "'add-file-repository'"
                        }
                      ],
                      staticClass: "btn-icon mt-1",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "from-repository"
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                      _vm._v(" Desde el repositorio ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.files, function(file) {
                return _c("div", { key: file.id, staticClass: "col-2" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "25px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              })
            ],
            2
          ),
          !!_vm.error.message
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-right"
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "cancel",
                color: "primary",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "save",
                color: "success",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Crear "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-primary"
              })
            ]
          )
        ],
        1
      ),
      _c("repository-selector", {
        attrs: {
          "modal-id": "add-file-repository",
          "add-file": _vm.addFileRepo,
          files: _vm.formData.files,
          "remove-file": _vm.removeFile
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }